"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SVGUtil = exports.IkeDrawLabel = void 0;
var mithril_1 = require("../mithril");
var theme_1 = require("../theme");
exports.IkeDrawLabel = {
    POINT: 'point',
    START: 'start',
    END: 'end',
    LABEL: 'label',
    IMAGE: 'image',
    DELETE: 'delete',
    ACCEPT: 'accept'
};
var SVGUtil = /** @class */ (function () {
    function SVGUtil() {
    }
    SVGUtil.DrawLine = function (pointA, pointB, strokeWidth, stroke, className) {
        var extraClassName = className ? ' ' + className : '';
        return (0, mithril_1.m)('line', {
            className: theme_1.ClassNames.line.container + extraClassName,
            stroke: stroke,
            'stroke-width': strokeWidth,
            x1: pointA.x,
            x2: pointB.x,
            y1: pointA.y,
            y2: pointB.y
        });
    };
    SVGUtil.DrawMoveLine = function (pointA, pointB, uiScale, label, className) {
        if (label === void 0) { label = exports.IkeDrawLabel.POINT; }
        var extraClassName = className ? ' ' + className : '';
        var strokeWidth = uiScale * theme_1.StyleConfig.STROKE_WIDTH * 10;
        var node = SVGUtil.DrawLine(pointA, pointB, strokeWidth, 'transparent', theme_1.ClassNames.line.move + ' ' + theme_1.ClassNames.isMoveable + ' ' + extraClassName);
        node.attrs['c-Draw-draggable'] = 'true';
        node.attrs['c-Draw-Label'] = label;
        return node;
    };
    SVGUtil.DrawLineMain = function (pointA, pointB, uiScale, className) {
        var extraClassName = className ? ' ' + className : '';
        var strokeWidth = uiScale * theme_1.StyleConfig.STROKE_WIDTH;
        return SVGUtil.DrawLine(pointA, pointB, strokeWidth * 2, theme_1.StyleConfig.STROKE, theme_1.ClassNames.line.main + extraClassName);
    };
    SVGUtil.DrawLineSecondary = function (pointA, pointB, uiScale, fillColor, className) {
        var extraClassName = className ? ' ' + className : '';
        var strokeWidth = uiScale * theme_1.StyleConfig.STROKE_WIDTH;
        return SVGUtil.DrawLine(pointA, pointB, strokeWidth, fillColor, theme_1.ClassNames.line.secondary + extraClassName);
    };
    SVGUtil.DrawLineBordered = function (pointA, pointB, uiScale, fillColor, className) {
        var borderLine = this.DrawLineMain(pointA, pointB, uiScale, className);
        var innerLine = this.DrawLineSecondary(pointA, pointB, uiScale, fillColor, className);
        return [borderLine, innerLine];
    };
    SVGUtil.DrawPoint = function (point, ctx) {
        var _a;
        var extraClassName = ctx.className ? ' ' + ctx.className : '';
        var attrs = {
            className: theme_1.ClassNames.point.container + extraClassName,
            cx: point.x,
            cy: point.y,
            r: ctx.radius || 0,
            fill: ctx.fill ? ctx.fill : theme_1.StyleConfig.LABEL.FILL,
            stroke: ctx.stroke ? ctx.stroke : theme_1.StyleConfig.LABEL.STROKE,
            'stroke-width': ctx.scale * theme_1.StyleConfig.STROKE_WIDTH,
            'c-Draw-draggable': ctx.draggable ? 'true' : null,
            'c-Draw-Label': (_a = ctx.label) !== null && _a !== void 0 ? _a : exports.IkeDrawLabel.LABEL
        };
        if (ctx.nodeId) {
            attrs['c-Draw-node-id'] = ctx.nodeId;
        }
        return (0, mithril_1.m)('circle', attrs);
    };
    return SVGUtil;
}());
exports.SVGUtil = SVGUtil;
//# sourceMappingURL=util.draw.svg.js.map